/** Mirrors backend MONTHLY_TRIAL_DAYS in billing_routes.py */
export const MONTHLY_TRIAL_DAYS = 2;

export const MONTHLY_TRIAL_CTA = `Start ${MONTHLY_TRIAL_DAYS}-day free trial`;
export const MONTHLY_TRIAL_SUBCOPY = "Then $24.99/mo · Cancel anytime · No charge today";

/** Pricing page hero (purchase-focused — not the landing discovery headline). */
export const PRICING_PAGE_HEADLINE = "Start free. Unlock companies. Apply ready.";
export const PRICING_PAGE_SUBTITLE = `${MONTHLY_TRIAL_DAYS}-day free trial · cancel anytime · no charge today`;

/** Shared plan definitions for Pricing page and paywall overlay. */
export const PRICING_PLANS = [
  {
    id: "weekly",
    title: "Weekly",
    badge: null,
    icon: "weekly",
    bullets: [
      "Unlock companies and apply this week.",
      "AI-tailor resumes for each role in your batch.",
    ],
    priceDisplay: "weekly_only",
    priceLabel: "$7.99",
    period: "/week",
    priceNote: "Billed weekly · cancel anytime",
    priceNoteExtra: "Paid week — not the free trial",
    savePercent: null,
    cta: "Try 1 week · $7.99",
    highlighted: false,
  },
  {
    id: "monthly",
    title: "Monthly",
    badge: "Recommended",
    icon: "monthly",
    bullets: [
      `${MONTHLY_TRIAL_DAYS}-day free trial · no charge today.`,
      "Unlock companies, tailor applications, track every move.",
    ],
    priceDisplay: "monthly_effective_weekly",
    priceLabel: "~$5.75",
    period: "/week",
    priceNote: "Billed $24.99/month · cancel anytime",
    priceNoteExtra: MONTHLY_TRIAL_SUBCOPY,
    savePercent: null,
    cta: MONTHLY_TRIAL_CTA,
    highlighted: true,
  },
  {
    id: "annual",
    title: "Annual",
    badge: null,
    icon: "annual",
    bullets: [
      "Same unlocks and AI prep — lowest weekly cost.",
      "One yearly charge · cancel anytime.",
    ],
    priceDisplay: "weekly_anchor",
    priceLabel: "~$1.35",
    period: "/week",
    priceNote: "Billed $69.99/year · cancel anytime",
    priceNoteExtra: null,
    savePercent: null,
    cta: "Go annual — $69.99/yr",
    highlighted: false,
  },
];
